export function getOutlineWidth(transformer) {
    return Object.freeze({
        default: transformer.outlineWidth('2px'),
    });
}
